export const QR_MENU_STYLE_OPTIONS = [
  { id: "classic", label: "Clasico", description: "Categorias en una barra y platos visibles en la misma pantalla." },
  { id: "bar", label: "Barra", description: "Categorias con fotos. El cliente elige una categoria, una subcategoria y luego sus platos." },
  { id: "grid", label: "Cuadricula", description: "Tarjetas con fotos en dos columnas en el celular. Categorias, subcategorias y platos paso a paso." },
];

export const normalizeQrMenuStyle = (value) =>
  QR_MENU_STYLE_OPTIONS.some((option) => option.id === value) ? value : "classic";
